import {
  PageBlueprint,
  createFrontendPlugin,
  createRouteRef,
} from '@backstage/frontend-plugin-api';
import AccountCircleOutlinedIcon from '@material-ui/icons/AccountCircleOutlined';

export const organizationSettingsRouteRef = createRouteRef();

const organizationSettingsPage = PageBlueprint.make({
  params: {
    path: '/settings',
    title: 'Organization identity',
    icon: <AccountCircleOutlinedIcon fontSize="small" />,
    routeRef: organizationSettingsRouteRef,
    loader: () =>
      import('./OrganizationPage').then(module => <module.OrganizationPage />),
  },
});

export const organizationSettingsPlugin = createFrontendPlugin({
  pluginId: 'organization-settings',
  title: 'Organization identity',
  icon: <AccountCircleOutlinedIcon fontSize="small" />,
  routes: { root: organizationSettingsRouteRef },
  extensions: [organizationSettingsPage],
});
